import { selectAllStrings } from '../features/language/languageSlice';
import { useSelector } from 'react-redux';

export const FormatDate = ({date, showDay = true}) => {
    const strings = useSelector(selectAllStrings);

    const dateObject = new Date(date.split(' ')[0]);
    let dateString = '';
    if (showDay) {
        dateString += dateObject.getDate() + ' ';
    }
    dateString += strings.monthNames[dateObject.getMonth()] + ' ' + dateObject.getFullYear();
    return dateString;
};